<template>
    <div class="w-full mx-auto px-1 overflow-hidden">
        <div class="pt-8 pb-6 flex justify-between flex-wrap items-top">
            <div class="pb-6">
                <p class="font-medium text-base text-costeaBlack">Costo mano de obra</p>
                <p
                    class="text-t12 font-normal text-costeaPressed w-full mt-2 bg-costeaBtn2 px-2 py-1 rounded-md mb-2 2xl:mb-2">
                    Si deseas agregar un costo de mano de obra externa, omita el campo <b class="text-bold">“Tiempo estándar
                        en horas"</b></p>
            </div>
            <div class="flex justify-center items-center">
                <button @click="cantManoObraDirecta++"
                    class="mr-4 flex bg-costeaPurpleDisabled hover:bg-costeaPurple hover:text-white cursor-pointer items-center px-4 py-2 text-costeaPurple text-t12 rounded-md">
                    <span>Agregar MOD</span>
                    <i class="ri-add-circle-fill ml-2 text-t14"></i>
                </button>
                <button @click="cantManoObraArea++"
                    class="flex bg-costeaBtn2 hover:bg-costeaBtn2Hover cursor-pointer items-center px-4 py-2 text-costeaPrimary text-t12 rounded-md">
                    <span>Agregar área</span>
                    <i class="ri-add-circle-fill ml-2 text-t14"></i>
                </button>
                <button v-if="rol_usuario != 3"
                    class="ml-4 flex  colorYellowCostea cursor-pointer items-center px-4 py-2  text-t12 rounded-md"
                    @click="toggleSorting">
                    <span>{{ this.isSortableEnabled ? 'Desactivar Ordenamiento ' : 'Habilitar Ordenamiento ' }} </span>
                    <i class="ri-drag-move-2-line ml-2 text-t14"></i>
                </button>



            </div>
        </div>

        <div class="w-full mt-4 justify-center items-start flex flex-col">
            <button v-if="false"
                class="mb-4 text-t12 bg-costeaPrimary text-white py-2 px-3 rounded-md border-0 hover:bg-costeaHover"
                @click="this.updateMod">Sincronizar MOD</button>
            <table id="tableManoDeObra" class="w-full">
                <thead class="font-costea text-t12 border-b-2 h-10 text-left">
                    <th></th>
                    <th class="pb-2"><span class="mr-8 cursor-pointer text-costeaDarkGray font-medium">Área fabricante del
                            producto</span></th>
                    <th class="pb-2"><span class="mr-4 cursor-pointer text-costeaDarkGray font-medium">Costo hora
                            hombre</span></th>
                    <th class="pb-2"><span class="mr-4 cursor-pointer text-costeaDarkGray font-medium text-center">Tiempo
                            estándar <br> en horas</span></th>
                    <th class="pb-2"><span class="mr-4 cursor-pointer text-costeaDarkGray font-medium">Costo por área</span>
                    </th>
                    <th class="pb-2"><span class="mr-4 cursor-pointer text-costeaDarkGray font-medium">Guardar/ <br>
                            Remover</span></th>
                </thead>
                <div class="h-5">
                </div>
                <tbody id="tableBody">
                    <tr v-if="isLoading" :class="{'skeleton' : isLoading}">
                        <td></td>
                        <td>
                            <input name="tipoIdentificacion" id="tipoIdentificacion" class="
                            bg-white
                            border-gray-200
                            border-solid
                            border-2
                            w-11/12
                            h-10
                            justify-start
                            items-center
                            outline-none
                            py-2
                            px-3
                            rounded-md
                            text-t14
                            mt-2" type="text" disabled  />
                        </td>
                        <td>
                            <input type="text" name="area" id="area" class="
                            bg-costeaContainer
                            w-8/12
                            h-10
                            flex
                            justify-start
                            items-center
                            outline-none
                            py-2
                            px-3
                            rounded-md
                            text-t14
                            mt-2" disabled/>
                        </td>
                        <td>
                            <input type="number" name="tiempo" id="tiempo" class="
                            bg-white
                            border-gray-200
                            border-solid
                            border-2
                            w-6/12
                            h-10
                            flex
                            justify-start
                            items-center
                            outline-none
                            py-2
                            px-3
                            rounded-md
                            text-t14 text-center mt-2" />
                        </td>
                       


                       
                    </tr>
                    <tr v-else  id="trTable" v-for="mod in modByProducts" :key="mod.index"
                        :class=" {'sort-handle': isSortableEnabled }" :data-row-id="mod.index">
                        <td></td>
                        <td>
                            <input name="tipoIdentificacion" id="tipoIdentificacion" class="
                            bg-white
                            border-gray-200
                            border-solid
                            border-2
                            w-11/12
                            h-10
                            justify-start
                            items-center
                            outline-none
                            py-2
                            px-3
                            rounded-md
                            text-t14
                            mt-2" type="text" disabled :value="mod.nombre_mod" />
                        </td>
                        <td>
                            <input type="text" name="area" id="area" class="
                            bg-costeaContainer
                            w-8/12
                            h-10
                            flex
                            justify-start
                            items-center
                            outline-none
                            py-2
                            px-3
                            rounded-md
                            text-t14
                            mt-2" disabled
                                :value="'$  ' + (mod.id_area !== null ? interNumberFormat(getCostoHorasHombre(mod.id_area) * 1) : interNumberFormat(filterModList(mod.mano_obra_directa_id).costo_hora_hombre))" />
                        </td>
                        <td>
                            <input type="number" name="tiempo" id="tiempo" class="
                            bg-white
                            border-gray-200
                            border-solid
                            border-2
                            w-6/12
                            h-10
                            flex
                            justify-start
                            items-center
                            outline-none
                            py-2
                            px-3
                            rounded-md
                            text-t14 text-center mt-2" :value="filterModList(mod.mano_obra_directa_id).tiempo_standar"
                                @change="(event) => updateTiempoStandar(mod.mano_obra_directa_id, event.target.value)" />
                        </td>
                        <td>
                            <span class="text-t14 cursor-pointer text-costeaGray">$ {{
                                mod.id_area !== null
                                ?
                                parseFloat(filterModList(mod.mano_obra_directa_id).tiempo_standar) !== 0
                                    ? interNumberFormat(getCostoHorasHombre(mod.id_area) *
                                        parseFloat(filterModList(mod.mano_obra_directa_id).tiempo_standar))
                                    : interNumberFormat(parseFloat(filterModList(mod.mano_obra_directa_id).costo_hora_hombre))
                                :
                                parseFloat(filterModList(mod.mano_obra_directa_id).tiempo_standar) !== 0
                                    ? interNumberFormat(parseFloat(filterModList(mod.mano_obra_directa_id).costo_hora_hombre) *
                                        parseFloat(filterModList(mod.mano_obra_directa_id).tiempo_standar))
                                    : interNumberFormat(parseFloat(filterModList(mod.mano_obra_directa_id).costo_hora_hombre))
                            }}</span>
                        </td>


                        <td>
                            <button @click="deleteManoObra(mod.mano_obra_directa_id)"
                                class="text-xs mx-2 cursor-pointer bg-costeaContainer text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaSalmon rounded-full w-5 h-5 flex justify-center items-center"><i
                                    class="ri-close-fill"></i></button>
                        </td>
                        <!-- <td>
                            <span class="sort-handle cursor-move pr-2"><i class="ri-drag-move-2-line"></i></span>

                        </td> -->
                    </tr>

                </tbody>
                <tbody v-for="(cant) in cantManoObraArea" :key="cant.index">
                    <ManoDeObraArea @removeManoObraArea="removeManoObraAreaHandler" @reloadData="reloadData" />
                </tbody>
                <tbody v-for="(cant, index) in cantManoObraDirecta" :key="index">
                    <ManoDeObraDirecta @removeManoObra='removeManoObraHandler' @reloadData="reloadData" />
                </tbody>
                <div class="h-4"></div>

                <tbody>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-t14 text-costeaDarkGray leading-10 py-4 rounded-md">
                        <span
                            class="text-t14 font-medium font-costea pr-3 leading-10 pl-4 inline-block border-t-2 border-gray-200">Total:</span>
                        <span
                            class="text-t16 font-costea text-costeaBlack leading-10 pr-4 inline-block font-bold border-t-2 border-gray-200">{{
                                (this.totalTiempoStandar
                                    ? interNumberFormat(this.totalTiempoStandar) : 0.00) }}</span>
                    </td>
                    <td></td>
                    <td></td>
                </tbody>
            </table>
        </div>



    </div>
</template>

<script>
import ManoDeObraArea from '@/components/productos/ManoDeObra/ManoDeObraArea.vue'
import ManoDeObraDirecta from '@/components/productos/ManoDeObra/ManoDeObraDirecta.vue'
import axios from 'axios'
import Sortable from 'sortablejs';
import { mapState } from 'vuex'
export default {
    name: "ManoDeObra",
    components: {
        ManoDeObraArea,
        ManoDeObraDirecta
    },
    data: function () {
        return {
            nums: [1, 2, 3, 4],
            cantManoObraArea: 0,
            cantManoObraDirecta: 0,
            listaManoObra: [],
            modByProducts: [],
            areas: [],
            isVisible: false,
            s: '',
            isSortableEnabled: false,
            sortable: null,
            interchangedMod: null,
            rol_usuario: localStorage.getItem("rol_usuario"),
            isLoading: true,


        }
    },
    methods: {
        toggleSorting() {
            this.isSortableEnabled = !this.isSortableEnabled
            this.sortable.option("disabled", !this.isSortableEnabled);

        },
        // saveOrderToLocalStorage() {
        //     if (localStorage) {
        //         localStorage.setItem('order', JSON.stringify(this.modByProducts.map(item => item.id)));
        //     }
        // },
        updateModOrder(newOrder) {
            // Crea un nuevo array para almacenar los elementos reordenados
            const updatedModByProducts = [];

            // Recorre el nuevo orden y actualiza los elementos en el array
            newOrder.forEach(rowId => {
                const index = parseInt(rowId);
                const mod = this.modByProducts[index];
                updatedModByProducts.push(mod);
            });

            // Asigna el nuevo array al array modByProducts
            this.modByProducts = updatedModByProducts;
        },
        saveRowOrder(newOrder) {
            // Envía los datos de la nueva ordenación al servidor para guardarlos en la base de datos
            // Obtener los registros de modByProducts en el nuevo orden
            const reorderedModByProducts = newOrder.map(rowId => {
                const index = parseInt(rowId);
                const mod = this.modByProducts[index];
                return {
                    id: mod.id, // Obtener el id del registro
                    productos_id: this.$route.params.id, // Obtener el productos_id del registro
                    mano_obra_directa_id: mod.mano_obra_directa_id,
                    orden: index // Usar el índice como nuevo orden
                };
            });

            // Enviar los datos al backend
            axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}saveRowOrder`, { reorderedModByProducts })
                .then(response => {
                    console.log('Orden de filas guardado en la base de datos:', response.data);
                    // this.getModByProducts()
                })
                .catch(error => {
                    console.error('Error al guardar el orden de las filas:', error);
                });
        },
        setData(data) {
            console.log(data)
        },
        updateTiempoStandar(id, tiempo) {
            let mod = this.filterModList(id)
            axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}mod-update/${id}`,
                {
                    id_area: mod.id_area,
                    nombre: mod.nombre,
                    costo_hora_hombre: mod.costo_hora_hombre,
                    tiempo_standar: tiempo,
                    costo_por_area: tiempo && tiempo != 0 ? (tiempo * mod.costo_hora_hombre) : mod.costo_hora_hombre
                })
                .then(
                    console.log('update Tiempo Standar'),
                    this.reloadData(true)
                ).catch(error => console.log(error))

            //console.log(id + '///' + tiempo + '//' + mod.id_area + '//' + mod.costo_por_area + '//' + mod.tiempo_standar)
        },
        interNumberFormat(number) {
            let interNF = new Intl.NumberFormat('es-CO');
            let numberDecimals = parseFloat(number)
            numberDecimals = numberDecimals.toFixed(2)
            return interNF.format(numberDecimals)
        },
        deleteManoObra(id) {
            let mods = []
            let prod = this.modByProducts
            console.log(this.modByProducts)
            for (var i = 0; i < prod.length; i++) {
                if (prod[i].mano_obra_directa_id != id) {
                    mods.push(prod[i].mano_obra_directa_id)
                } else {
                    continue;
                }
            }
            axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto/mod-add/${this.$route.params.id}`, { mano_obra_directa_id: mods })
                .then(
                    this.reloadData(true)
                ).catch(error => console.log(error));
        },
        async reloadData(value) {

            if (value === true) {
                this.isLoading = true
                await this.getAreas()
                await this.getModDetails()
                await this.getModByProducts()
                this.$emit('reloadData', true)
                value = false
                this.isLoading = false

            } else {
                console.log('Ocurrio un error')
            }
        },
        removeManoObraHandler(value) {
            this.cantManoObraDirecta += value
        },
        removeManoObraAreaHandler(value) {
            this.cantManoObraArea += value
        },
        async getModByProducts() {
            await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
                .then(response => {
                    this.modByProducts = response.data.data.modirectas.map((mod, index) => {
                        return {
                            ...mod,
                            index: index
                        };
                    });

                    // Sort the modByProducts array by the 'orden' field
                    // this.modByProducts.sort((a, b) => a.orden - b.orden);
                })
                .catch(error => console.log(error));

        },
        async getModDetails() {
            await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}mod`)
                .then(
                    response => {
                        this.listaManoObra = response.data
                    }
                ).catch(
                    error => console.log(error)
                )
        },
        async getAreas() {
            await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}areasempresa`)
                .then(response => {
                    this.areas = response.data;
                })
                .catch(error => console.log(error))
        },
        /*filterArea(areaSelected){
              let name
              for(let i = 0; i < this.areas.length ; i++){
                if(this.areas[i].id == Number(areaSelected)){
                  name = this.areas[i].name
                }
              }
              let areaFilter = {
                name: name,
              }
              console.log(areaFilter)
              return areaFilter.name
          },*/
        filterMod(id) {
            let costoHora = id;
            let tiempo = 0;
            let costoArea = 0;
            /*for(let i=0; i< this.mods.length;i++ ){
                if(this.mods[i].id === Number(id)){
                    costoHora = 1
                    tiempo = 1
                    costoArea = 1
                }
            }*/
            console.log(costoHora, tiempo, costoArea)
            return tiempo
        },
        filterModList(id) {
            let data = this.listaManoObra.find(mod => mod.id == id);

            if (!data) {
                return {
                    id: null,
                    costo_hora_hombre: 0,  // valor predeterminado
                    tiempo_standar: 0     // valor predeterminado
                    // puedes agregar más propiedades aquí si es necesario
                };
            }

            return data;
        },

        filterAreaList(id) {
            let data
            data = this.areas.find(area => { return area.id == id })
            return data
        },
        getCostoHorasHombre(id) {
            //buscar ID en el array areas
            let area = this.areas.find((i) => i.id == id);
            if (area) {
                let totalCostoArea = area.costo_total_del_area
                let diasHabiles = area.dias_habiles_mes
                let horasDia = area.horas_por_dia
                let horasDisponiblesMes = diasHabiles * horasDia
                let trabajadoresArea = area.numero_de_personas

                let costo = totalCostoArea / (horasDisponiblesMes * trabajadoresArea)
                costo = costo.toFixed(2)
                return costo
            }
            return 0
        },
        async updateMod() {
            let mod = this.modByProducts
            //recorrer mods y calcular la suma del costo total de cada mod
            let costoTotal = 0
            for (let i = 0; i < mod.length; i++) {
                if (mod[i].id_area !== null) {
                    costoTotal += (
                        this.getCostoHorasHombre(mod[i].id_area) *
                        this.filterModList(mod[i].mano_obra_directa_id).tiempo_standar
                    )
                } else {
                    costoTotal += (
                        this.filterModList(mod[i].mano_obra_directa_id).costo_hora_hombre *
                        this.filterModList(mod[i].mano_obra_directa_id).tiempo_standar
                    )
                }
            }
            let data = {
                costo_mano_obra: costoTotal
            }
            await axios.put(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}updateMod/${this.$route.params.id}`, data).then(
                response => {
                    console.log(response)
                }
            ).catch(error => console.log(error))

            this.reloadData(true)
            return costoTotal
        },
    },
    computed: {
        ...mapState(['costea']),
        totalTiempoStandar() {
            let total = 0;
            this.modByProducts.forEach(element => {
                // console.log("ELEMENTO", this.filterModList(element.mano_obra_directa_id))
                // console.log("MANO OBRA!!!", this.filterModList(element.mano_obra_directa_id).tiempo_standar)
                let tiempo = Number(this.filterModList(element.mano_obra_directa_id).tiempo_standar)
                total += tiempo;
            });
            return total
        },
    },
    async mounted() {
        await this.getAreas()
        await this.getModDetails()
        await this.getModByProducts()
        this.isLoading = false

        // await this.updateMod()
        // const table = document.getElementById('tableManoDeObra'); 
        const tableBody = document.getElementById('tableBody');
        this.sortable = Sortable.create(tableBody, {
            disabled: true,
            // ...

            onUpdate: event => {
                const rows = Array.from(event.to.children);
                const newOrder = rows.map(row => row.dataset.rowId);

                this.updateModOrder(newOrder); // Actualiza el orden en el array modByProducts
                this.saveRowOrder(newOrder); // Guarda el orden en el backend
            },
        });

    }
}
</script>

<style>
.skeleton {
  position: relative;
  width: 100%;
  /* Ancho del skeleton */
  height: auto;
  /* Altura del skeleton */
  overflow: hidden;
  /* Oculta el desbordamiento del pseudo-elemento */
  color: transparent
}

.skeleton::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: transparent;
  background-color: #f2f2f2;
  /* Color de fondo del skeleton */
  animation: skeleton-loading 1s infinite ease-in-out;
  /* Animación del skeleton */
}

@keyframes skeleton-loading {
  0% {
    opacity: 0.7;
    /* Opacidad inicial del skeleton */
  }

  50% {
    opacity: 0.4;
    /* Opacidad intermedia del skeleton */
  }

  100% {
    opacity: 0.7;
    /* Opacidad final del skeleton */
  }
}
th {
    height: 40px;
}

td {
    margin: 10px 0px;
}

.selected {
    /* outline-color: #3b82f6; */
    border: 2px dashed red;

    /* background-color: rgb(94 234 212); */
}

.sort-handle {
    cursor: move;

}

.sort-handle.sortable-chosen {
    border: 2px dashed rgba(219, 210, 254);
}

.colorYellowCostea {
    background-color: #fff0d9;
    color: #ff9e0f
}

.colorYellowCostea:hover {
    background-color: #ff9e0f;
    color: #ffffff
}</style>